import { useEffect } from "react";
import { RouterProvider } from "react-router";
import { router } from "./Utils/Constants/Routes";
import { loadSearchIndex } from "Data/Search/SearchActions";
import "./App.css";
import { useAppDispatch } from "Data/Store/hooks";

function App() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(loadSearchIndex());
  }, [dispatch]);

  return <RouterProvider router={router} />;
}

export default App;
